import React, { useEffect, useState } from "react";
import { Shell, Section } from "@/components/loomi/Layout";
import { ADMIN_NAV } from "./AdminDashboard";
import { api } from "@/lib/api";
import { LogsTable } from "./AdminProjectDetail";

export default function AdminLogs() {
  const [logs, setLogs] = useState([]);
  const [audit, setAudit] = useState([]);
  useEffect(() => {
    (async () => {
      const [l, a] = await Promise.all([api.get("/admin/logs"), api.get("/admin/audit")]);
      setLogs(l.data); setAudit(a.data);
    })();
  }, []);
  return (
    <Shell title="Redirect logs & audit" portalLabel="Admin" nav={ADMIN_NAV}>
      <div className="grid md:grid-cols-2 gap-6">
        <Section title="Redirect events" testId="section-redirect-logs">
          <LogsTable logs={logs} />
        </Section>
        <Section title="Admin/PM audit" testId="section-audit-logs">
          {audit.length === 0 ? (
            <div className="text-mute text-sm py-8 text-center" data-testid="audit-empty">No audit events yet.</div>
          ) : (
            <div className="max-h-[380px] overflow-y-auto">
              <table className="w-full text-xs" data-testid="audit-table">
                <thead>
                  <tr className="text-left text-[10px] uppercase tracking-widest text-mute border-b border-white/10">
                    <th className="py-2 pr-3">Time</th><th className="py-2 pr-3">Role</th><th className="py-2 pr-3">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {audit.map((a) => (
                    <tr key={a.id} className="border-b border-white/5">
                      <td className="py-2 pr-3 font-mono text-mute">{new Date(a.timestamp).toLocaleString()}</td>
                      <td className="py-2 pr-3">{a.role}</td>
                      <td className="py-2 pr-3 font-mono">{a.action}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Section>
      </div>
    </Shell>
  );
}
